import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

// Wachtwoordbeleid zoals de server het afdwingt (RequiredLength 10, RequireDigit, zie
// ServiceCollectionExtensions.eAddIdentity). Gedeeld door Register, Recover en PasswordChange.
export const passwordValidators: ValidatorFn[] = [
    Validators.required,
    Validators.minLength(10),
    Validators.pattern(/\d/),
];

// Wachtwoord en herhaling moeten overeenkomen; fout op group-niveau zodat beide velden 'm zien.
export function passwordMatchValidator(passwordKey: string, passwordRepeatKey: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const __password = group.get(passwordKey)?.value;
        const __passwordRepeat = group.get(passwordRepeatKey)?.value;

        return __password && __passwordRepeat && __password !== __passwordRepeat
            ? { passwordMismatch: true }
            : null;
    };
}
